<div class="paginator flex justify-between items-center mt-4">
  <div class="flex items-center gap-2">
    <span class="elements-on-page-label hidden" for="elementsOnPage"
      >{{ "pagination.show" | transloco }}:</span
    >
    <ng-select
      class="er-select"
      [items]="[10, 25, 50]"
      (change)="changePageSize.emit($event)"
      [ngModel]="defaultPageSize"
      [clearable]="false"
      [searchable]="false"
    />
  </div>
  <div class="default-paginator">
    <mat-paginator
      libErPagination
      [length]="totalRecords"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [hidePageSize]="true"
      (page)="changePageIndex.emit($event)"
    >
    </mat-paginator>
  </div>

  <div class="mobile-paginator flex items-center justify-between gap-[20px]">
    <button
      mat-icon-button
      [disabled]="pageIndex === 0"
      (click)="prev()"
      aria-label="Previous page"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div
      class="w-[32px] h-[32px] rounded-full bg-grayscale-dark text-white grid place-items-center font-semibold"
    >
      {{ pageIndex + 1 }}
    </div>
    <button
      mat-icon-button
      [disabled]="(pageIndex + 1) * pageSize >= totalRecords"
      (click)="next()"
      aria-label="Next page"
    >
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
</div>
